import { create } from 'zustand'
import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { StoryBlokCarReviewSection } from '../../types/car-review-page'

export interface ImageIndexes {
  interiorSectionImageIndex: number | undefined
  performanceSectionImageIndex: number | undefined
  practicalitySectionImageIndex: number | undefined
  runningCostsSectionImageIndex: number | undefined
}

export interface ReviewSections {
  interior: StoryBlokCarReviewSection
  performance: StoryBlokCarReviewSection
  practicality: StoryBlokCarReviewSection
  runningCosts: StoryBlokCarReviewSection
}

interface VehicleGalleryStore {
  setImageIndex: (index: number) => Promise<void>
  imageIndex: number | null
  imageIndexes: ImageIndexes | null
  setImageIndexes: (
    images: StoryblokImage[] | undefined,
    sections: ReviewSections,
  ) => void
}

export const useVehicleGallery = create<VehicleGalleryStore>((set) => ({
  setImageIndex: (index: number) =>
    new Promise((res) => res(set({ imageIndex: index }))),
  imageIndex: null,
  imageIndexes: null,
  setImageIndexes: (
    images: StoryblokImage[] | undefined,
    sections: ReviewSections,
  ) => {
    const interiorSectionImageIndex = images
      ?.map((image) => image.id)
      .indexOf(sections.interior.image?.id)

    const performanceSectionImageIndex = images
      ?.map((image) => image.id)
      .indexOf(sections.performance.image?.id)

    const practicalitySectionImageIndex = images
      ?.map((image) => image.id)
      .indexOf(sections.practicality.image?.id)

    const runningCostsSectionImageIndex = images
      ?.map((image) => image.id)
      .indexOf(sections.runningCosts.image?.id)

    set({
      imageIndexes: {
        interiorSectionImageIndex,
        performanceSectionImageIndex,
        practicalitySectionImageIndex,
        runningCostsSectionImageIndex,
      },
    })
  },
}))
